import {
  formatCategoryName,
  formatCurrency,
  formatPaymentMonth,
  regularityTone,
} from "./dashboardUtils";

export default function RegularityTimeline({ regularity }) {
  const months = regularity?.months || [];

  return (
    <section className="rounded-2xl bg-white p-4 shadow sm:p-5">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-zinc-950">
            Chanda Regularity
          </h3>
          <p className="text-sm text-zinc-500">
            A month is fully paid only when both membership and ijtima
            categories are paid
          </p>
        </div>
        <p className="text-sm text-zinc-500">
          Current streak:{" "}
          <span className="font-semibold text-zinc-900">
            {regularity?.currentStreak || 0}
          </span>
        </p>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {months.map((month) => {
          const tone = regularityTone(month.status);
          return (
            <div
              key={month.paymentMonth}
              className={`rounded-xl border p-3 ${tone.border} ${tone.bg}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div>
                  <p className={`text-sm font-semibold ${tone.text}`}>
                    {formatPaymentMonth(month.paymentMonth)}
                  </p>
                  <p className={`mt-1 text-xs ${tone.text}`}>{tone.label}</p>
                </div>
                <p className={`text-sm font-semibold ${tone.text}`}>
                  {formatCurrency(month.mandatoryAmount)}
                </p>
              </div>
              {month.missingMandatoryCategories?.length > 0 &&
                month.status !== "FUTURE" && (
                  <p className={`mt-2 text-xs ${tone.text}`}>
                    Missing:{" "}
                    {month.missingMandatoryCategories
                      .map(formatCategoryName)
                      .join(", ")}
                  </p>
                )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
